const Mascot = ({ src, name, size, delay, glow, testId, className }) => (
  <div className={`relative inline-block ${className}`} style={className ? undefined : { width: size }} data-testid={testId}>
    <img
      src={src}
      alt={name}
      draggable="false"
      className={`w-full h-auto select-none mascot-wiggle ${glow}`}
      style={{ animationDelay: delay }}
    />
  </div>
);

export const LumiMascot = ({ size = 160, className = "" }) => (
  <Mascot src="/img/lumi.webp" name="Lumi" size={size} delay="0s" glow="lumi-glow" testId="lumi-mascot" className={className} />
);

export const SparkMascot = ({ size = 160, className = "" }) => (
  <Mascot src="/img/spark.webp" name="Spark" size={size} delay="0.9s" glow="spark-glow" testId="spark-mascot" className={className} />
);
